module.exports = __webpack_public_path__ + "static/media/Blueprism_logo.b3d0141a.svg";